<template>
    <header class="header">
        <div class="banner">
            <a href="/"><img src="../assets/pp_logo.png" height="42" style="margin:4px; float:left"></a>
            <span class="system">Premia Process Management System</span>
            <span class="tools">
                <span v-if="global.currentUser==null"><a href="/user/login" title="Sign In" style="margin-right:10px;">
                    <i class="fa fa-user" ></i><span class='text'>Sign in</span></a></span>
                <span v-else><img class="avatar" :src="'https://workflow.premia-partners.com/user-api'+global.currentUser.avatar"/>
                    <span class='text name'>{{global.currentUser.loginname}}</span></span>
                <a href="/user/changePassword" v-if="global.currentUser != null" title="Change Password" style="margin-right:10px;">
                    <i class="fa fa-gear"></i></a>
                <a href="" title="Sign Out" v-if="global.currentUser != null"><i class="fa fa-sign-out" @click.prevent="logout"></i></a>
            </span>
        </div>
    </header>
</template>

<script>

import {Setting, SwitchButton, Avatar} from '@element-plus/icons'
import 'font-awesome/css/font-awesome.min.css'
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    components: {
        Setting, SwitchButton, Avatar
    },
    data() {
        return {
            global,
        }
    },
    //props: ['currentUser'],
    methods: {
        async logout() {
            let result = await AXIOS('/logout');
            if (result.success) {
                this.global.logout();
                this.$router.push("/user/login");
            }
        }
    }
}
</script>

<style scoped>
    .header {
        display:flex;
        align-content: flex-start; 
        width:100%;
        background:#f9F9F9;
        border-bottom:1px solid #ddd;
    }
    .banner {
        width:1100px;
        height:50px;
        margin:0px auto;
    }
    .system {
        font-size:24px;
        font-family: Arial, 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        display:inline-block;
        line-height:50px;
        color:#333;
        margin-left:60px;
    }
    .tools {
        float: right;
        line-height:50px;
        text-align:right;
        font-size:18px;
    }
    .tools a {
        color:#01b1af;
        text-decoration: none;
        font-size:20px;
    }
    .tools .text {
        font-size:16px;
        padding:0px 10px 0px 5px;
    }
    .tools .name {
        color:#666;
    }
    .tools i {
        vertical-align: middle;
    }
    .avatar {
        display:inline-flex;
        vertical-align: middle;
        height:40px;
        border-radius: 20px;
        border:1px solid #ddd;
        margin-bottom:3px;
    }
</style>